import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { InvoiceMessaging, InvoiceTitle } from 'src/app/shared/services/Invoice-messaging.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent {

  loading: boolean = true;
  isSuccess:boolean=true;
  walletDetails;
  paidInvoiceDetails;
  cashPointsEarned;
  achPointsEarned;
  earlyPointsEarned;
  totalPointsEarned;
  messageResponse:string='';
  messageHeading:string='';
  isPPI:boolean=false;
  isBilliant:boolean=false;

  constructor(
    public router:Router,
    private userService: UserService,public sessionServiceAPI:SessionService
  ){}

  ngOnInit() {
    this.paidInvoiceDetails = JSON.parse(sessionStorage.getItem('paidInvoice'));
    this.isBilliant = sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
    if (this.paidInvoiceDetails) {
      this.cashPointsEarned = this.paidInvoiceDetails.cashPointsEarned;
      this.achPointsEarned = this.paidInvoiceDetails.achPointsEarned;
      this.earlyPointsEarned = this.paidInvoiceDetails.earlyPointsEarned;
      this.totalPointsEarned = Number(parseInt(this.cashPointsEarned) + parseInt(this.achPointsEarned) + parseInt(this.earlyPointsEarned)).toFixed(0);
      this.isSuccess=this.paidInvoiceDetails.isSuccess;
      this.messageResponse=this.ChooseResponseMessage(this.paidInvoiceDetails.messageCode);
      this.messageHeading=this.ChooseResponseTitle(this.paidInvoiceDetails.messageCode);
      this.isPPI=this.sessionServiceAPI.isPPI() ?? false;
      this.getWalletDetails(); // Once we make an invoice payment, we need to update wallet details. But even if it fails, show the details of the invoice they just paid
    } else {
      this.router.navigate(['home']);
    }
  }

  ChooseResponseMessage(statusLevel:string):string
  {
    if (statusLevel.includes('E1') || statusLevel.includes('E3')) { return InvoiceMessaging.E1E3; }
    else if (statusLevel.includes('E2')) { return InvoiceMessaging.E2; }
    else if (statusLevel.includes('E4') || statusLevel.includes('E6')) { return InvoiceMessaging.E4E6; }
    else if (statusLevel.includes('E5')) { return InvoiceMessaging.E5; }
    else if (statusLevel.includes('E7')) { return InvoiceMessaging.E7; }
    else { return ''; }

  }

  ChooseResponseTitle(statusLevel: string): string {

    if (statusLevel.includes('E1') || statusLevel.includes('E3') || statusLevel.includes('E2')) { return InvoiceTitle.Rewards; }

    else if (statusLevel.includes('E4') || statusLevel.includes('E6') || statusLevel.includes('E5')) { return InvoiceTitle.Cash; }
    else if (statusLevel.includes('E7')) { return InvoiceTitle.Token; }
    else { return ''; }

  }

  ngOnDestroy() {
    sessionStorage.removeItem('paidInvoice');
  }

  backToRewards(){
    this.router.navigate(['my-wallet/all-rewards/']);
  }

  backToHome(){
    this.router.navigate(['home']);
  }

  getWalletDetails() {
    this.loading = true;
    let request = {
      walletID: JSON.parse(sessionStorage.getItem('WalletID')!),
      walletRole: JSON.parse(sessionStorage.getItem('WalletRole')!),
      sessionID: sessionStorage.getItem('SessionID')
    }
    this.userService.getWalletSummary(request).subscribe(
      data => {    
        if(data.onl.wallet.walletID!=null)
          {
            data.wallet=data.onl.wallet;
          }
          else{
            data.wallet=data.ppi.wallet;
          }   
        if (data?.wallet) {
          sessionStorage.setItem('walletDetails', JSON.stringify(data.wallet));
          this.walletDetails = data.wallet;
        } else {
          // Try to retrieve information from sessionStorage.
          this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);
        }

        window.scrollTo(0, 0);
        this.loading = false;
      }, error => {
        // Even if the API fails, we can try to retrieve the information from sessionStorage
        this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);
        window.scrollTo(0, 0);
        this.loading = false;
      }
    );
  }
}
